export default "__VITE_ASSET__D$9G73L3__"